import { createEntityAdapter, EntityState } from "@ngrx/entity";
import { JiraStory } from "../../models/jiraStory";
import { TestCase, TestCaseVersions } from "../../models/testCase";

// Define TestCaseGenerator State
export interface TestCaseGeneratorState {
  jiraStories: EntityState<JiraStory>;
  testCases: EntityState<TestCase>;
  testCasesByVersionId: EntityState<TestCase>;
  testCaseVersions: EntityState<TestCaseVersions>;
  generating: boolean;
  loading: boolean;
  loadingTestCases: boolean;
  error: string | null;
  versionId: any;
  message: string;
}

export const jiraAdapter = createEntityAdapter<JiraStory>({
  selectId: (story) => story.key,
});

export const testCaseAdapter = createEntityAdapter<TestCase>({
  selectId: (testCase) => testCase.testCaseId,
});

/** Prefer Mongo `_id`; BPD reuses display `testCaseId` across hubs so fall back to a composite. */
export const testCaseByVersionIdAdapter = createEntityAdapter<TestCase>({
  selectId: (testCase: any) => {
    if (testCase?._id) return String(testCase._id);
    const story = testCase?.key || testCase?.userStoryId || '';
    const tcId = testCase?.testCaseId || '';
    if (story && tcId) return `${story}::${tcId}`;
    return tcId;
  },
});

export const testCaseVersionAdapter = createEntityAdapter<TestCaseVersions>({
  selectId: (version) => version.versionName
})

// Initial State
export const initialState: TestCaseGeneratorState = {
  jiraStories: jiraAdapter.getInitialState(),
  testCases: testCaseAdapter.getInitialState(),
  testCasesByVersionId: testCaseByVersionIdAdapter.getInitialState(),
  testCaseVersions: testCaseVersionAdapter.getInitialState(),
  generating: false,
  loading: false,
  loadingTestCases: false,
  error: null,
  versionId: null,
  message: ''
};
